// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"8839d93b","612":"8839d93b"}[chunkId] + ".chunk.css";
};